<div class="announcements-container">
    <div class="page-section-header">
      <div *ngIf="!isLoading" class="page-section-buttons">
        <a (click)="doCreate()" (keypress)="doCreate()" class="btn btn-primary btn-with-icon" translate>Create Announcement</a>
      </div>
      <h2>Announcement Activities</h2>
    </div>
  
    <!-- Announcements List -->
    <div class="announcements-list">
      <div *ngIf="isLoading" class="loading">
        Loading announcements...
      </div>
      
      <div *ngIf="!isLoading && activeAnnouncements.length === 0 && expiredAnnouncements.length === 0" class="no-announcements">
        No announcements available
      </div>
  
      <div *ngIf="!isLoading && (activeAnnouncements.length > 0 || expiredAnnouncements.length > 0)" class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th style="width: 40%">Message Title</th>
              <th style="width: 15%">Start Date</th>
              <th style="width: 15%">End Date</th>
              <th style="width: 10%">Status</th>
              <th style="width: 10%"></th>
              <th style="width: 10%">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let announcement of activeAnnouncements">
              <td>{{ announcement.Title }}</td>
              <td>{{ announcement.StartDate | date }}</td>
              <td>{{ announcement.EndDate | date }}</td>
              <td>Active</td>
              <td><a tabindex="0" class="pull-right" (click)="viewAnnouncement(announcement)" translate>View</a></td>
              <td><a tabindex="0" class="pull-right" (click)="editAnnouncement(announcement)" translate>Edit</a></td>      
            </tr>
            <tr *ngFor="let announcement of expiredAnnouncements" class="expired">
              <td>{{ announcement.Title }}</td>
              <td>{{ announcement.StartDate | date }}</td>
              <td>{{ announcement.EndDate | date }}</td>
              <td>Expired</td>
              <td><a tabindex="0" class="pull-right" (click)="viewAnnouncement(announcement)" translate>View</a></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div> 